import React, { type FC, useEffect, useRef } from 'react';
import classNames from 'classnames';

import styles from './AnimationTitle.module.scss';

type AnimationTitleProps = {
  title: string;
  animating: boolean;
  stopAnimating: VoidFunction;
  className?: string;
};

export const AnimationTitle: FC<AnimationTitleProps> = ({
  title,
  animating,
  stopAnimating,
  className,
}) => {
  const animationTimerId = useRef<NodeJS.Timer | null>(null);

  const wrapperClassNames = classNames(styles.root, {
    [styles.animationRun]: animating,
    [styles.animationClose]: !animating,
  }, className);

  useEffect(() => {
    if (animating) {
      animationTimerId.current = setTimeout(() => {
        stopAnimating();
      }, 800);
    }

    return () => {
      if (animationTimerId.current) {
        clearTimeout(animationTimerId.current);
        animationTimerId.current = null;
      }
    };
  }, [animating]);

  return (
    <p className={wrapperClassNames}>{title}</p>
  );
};
